
<template>
  <div v-loading="loading"
    element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)">
      <div class="hello flex indexmin"  v-if="this.ml">
        <div class="home-left">
          <div class="home-left-top flex">
            <div class="home-left-top-one">
              <div class="home-left-top-content">
                <h3 class="a-title">账户可提余额</h3>
                <div class="flex">
                  <div class="home-left-top-capital">
                    <strong>{{currUserinfo.CurrWithdrawAble}}</strong>
                    <span style="color:red;font-size:30px;"></span>{{CurrencyName}}<br>
                    <!-- <span>总收入（{{currUserinfo.TotalCommissionProfit}} {{currUserinfo.CurrencyNo}}）</span>   -->
                  </div>
                  <div class="home-left-top-option">
                    <el-button type="primary" size="small" @click="select()">充值</el-button>
                    <!-- 个人实名认证 -->
                    <!-- <el-button type="warning" size="small" id="personalAuth" @click="PersonalAuthDialogForm  = true">实名认证</el-button> -->
                    <!-- 提现 -->
                    <el-button type="warning" size="small" id="goWithdraw" @click="withdrawdeposit()" v-show="true" style="width:54px;height:30px;">提现</el-button>
                  </div>
                </div>
              </div>
            </div>
            <div class="home-left-top-one">
              <div class="home-left-top-content">
                <h3 class="a-title">资金信息</h3>
                <div class="flex">
                  <div class="home-left-top-capital">
                    <strong style="font-size:22px;color:#000">{{currUserinfo.CurrUse}}</strong><br>
                    <span>账户可用余额({{CurrencyName}})</span>
                  </div>
                  <div class="home-left-top-capital">
                    <strong style="font-size:22px;color:#000">{{currUserinfo.TotalWithdraw}}</strong><br>
                    <span>已提取({{CurrencyName}})</span>
                  </div>
                  <div class="home-left-top-capital">
                    <strong style="font-size:22px;color:#000">{{currUserinfo.FrozenMoney}}</strong><br>
                    <span>提现中({{CurrencyName}})</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="home-left-bottom" style="position:relative;" v-show="isShowCashRecord">
            <el-tabs v-model="activeName">
              <el-tab-pane label="充值记录" name="first">
                <el-table :data="QueryHistoryMoneyTransfers" style="width: 100%;" v-loading="loading">
                  <el-table-column type="index" label="序号">
                  </el-table-column>
                  <el-table-column prop="TransferMoney" :label="'金额('+ CurrencyName +')'">
                  </el-table-column>
                  <el-table-column prop="Id" label="交易号">
                  </el-table-column>
                  <el-table-column prop="AddDate" label="创建日期">
                  </el-table-column>
                  <el-table-column prop="OrderState" label="状态">
                  </el-table-column>
                </el-table>
              </el-tab-pane>
              <el-tab-pane label="提现记录" name="second">
                <el-table :data="withdrawList" style="width: 100%" v-loading="loading">
                  <el-table-column type="index" label="序号">
                  </el-table-column>
                  <el-table-column prop="TransferMoney" :label="'金额('+ CurrencyName +')'">
                  </el-table-column>
                  <el-table-column prop="Id" label="交易号">
                  </el-table-column>
                  <el-table-column prop="AddDate" label="创建日期">
                  </el-table-column>
                  <el-table-column prop="OrderState" label="状态">
                  </el-table-column>
                </el-table>
              </el-tab-pane>
            </el-tabs>
            <div class="line" style="width:1px;height:16px;background-color:#dbdbdb;position:absolute;top:12px;left:95px;"></div>
            <div style="position:absolute;top:10px;left:93%;">
              <!-- <router-link to="/history"></router-link> -->
              <a href="javascript:void(0);" @click="routerto()">更多...</a>
            </div>
          </div>
        </div>
        <div class="home-right">
          <div class="bind-card" v-show="!displayCard">
            <div class="bind-card-button" @click="showBindCardPage()">
              <div class="bind-card-button-in">
                +
              </div>
            </div>
            <p style="padding-top:23px;">新增银行卡</p>
          </div>
          <div class="bankCardInfo" v-show="displayCard">
            <h3>我的银行卡
              <!-- <span>修改</span> -->
            </h3>
            <div class="mine-info-list1">
              <div class="mcode square">
                银行名称：{{SubbranchName}}
              </div>
              <div class="mname square">
                银行卡号：<span style="color:#2399F1;cursor:pointer;">{{CardNO}}</span>
              </div>
            </div>
          </div>
          <div style="height:calc(100% - 183px)">
            <div class="mine-info">
              <h3>我的信息</h3>
              <div class="mine-info-list">
                <div class="mname square">
                  我的姓名：{{usernameinfo}}
                </div>
                <div class="mphone square" v-show="insTestProp.UserRelyPhone">
                  手机号码：
                  <span style="color:#2399F1;cursor:pointer;"  v-show="noPhone" @click="showbindphone()"> 绑定 </span>            
                  <span style="color:#2399F1;cursor:pointer;"  v-show="havePhone">{{currAgentInfo.BindPhone}}</span>
                  <span style="color:#2399F1;cursor:pointer;"  v-show="havePhone" @click="showbindphone()">修改 </span>
                </div>
              </div>
            </div>
            <div class="mine-2d-code">
              <h3>我的证件</h3>
              <el-button type="primary" size="small" @click="openWallet()" v-if="!WalletOpenResult.IsOpen && isShowWallet">开通有钱钱包</el-button>
              <el-button type="primary" size="small" @click="gotoWallet()" v-if="WalletOpenResult.IsOpen && isShowWallet">去往有钱钱包</el-button>
              <!-- <el-popover
                v-if="WalletOpenResult.IsOpen && isShowWallet"
                popper-class='wallet-popper'
                placement="top-start"
                title="有钱钱包APP下载(Android)"
                trigger="hover">
                <div class="img">
                  <img :src="walletAndroidDownUrl" alt="">
                </div>
                <el-button slot="reference" type="primary" size="small">有钱钱包(Android)</el-button>
              </el-popover>
              <el-popover
                v-if="WalletOpenResult.IsOpen && isShowWallet"
                popper-class='wallet-popper'
                placement="top-start"
                title="有钱钱包APP下载(IOS)"
                trigger="hover">
                <div class="img">
                  <img :src="walletIOSDownUrl" alt="">
                </div>
                <el-button slot="reference" type="primary" size="small">有钱钱包(IOS)</el-button>
              </el-popover> -->
              
              
              <div class="mine-info-list" style="padding-top: 20px;">
                <!-- <template v-if="WalletOpenResult.IsOpen && isShowWallet">
                  <div class="mname square">
                    钱包姓名：<span style="color:#2399F1;cursor:pointer;"> {{WalletOpenResult.AccName}} </span>
                  </div>
                  <div class="mname square">
                    钱包账户：<span style="color:#2399F1;cursor:pointer;"> {{WalletOpenResult.AccNo}} </span>
                  </div>
                  <div class="mname square">
                    钱包余额：<span style="color:#2399F1;cursor:pointer;"> {{WalletOpenResult.Amount}} </span><el-button type="primary" size="small" @click="WalletWithdrawFn()">提现</el-button>
                  </div>
                  <hr>
                </template> -->
                <div class="mname square">
                  证件类型：身份证
                </div>
                <div class="mphone square">
                  身份证号：
                  <span style="color:#2399F1;cursor:pointer;"  v-show="noid" @click="showbindid()"> 绑定 </span>
                  <span style="color:#2399F1;cursor:pointer;"   v-show="haveid">{{IDCardNo}}</span>
                  <!--认证中 -->
                  <span style="color:#2399F1;cursor:pointer;"   v-show="btnAuthing"> 认证中,请稍等！ </span>
                  <!-- 未通过 -->
                  <span style="color:#2399F1;cursor:pointer;" @click="showbindid()"  v-show="nobind"> 未通过，请重新认证！ </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="hello flex" v-if="this.xx">
        <div class="home-left">
          <div class="home-left-top flex">
            <div class="home-left-top-one">

                <h3 class="a-title"> <i class="iconfont icon-zijin"></i> 账户可提余额</h3>

                  <div class="home-left-top-capital">
                    <strong>{{currUserinfo.CurrWithdrawAble}}</strong>
                    <span style="color:red;font-size:30px;"></span>{{CurrencyName}}<br>
                  </div>
                  <div class="home-left-top-option">
                    <el-button type="primary" size="small" @click="select()">充值</el-button>
                    <el-button type="warning" size="small" id="goWithdraw" @click="withdrawdeposit()" v-show="true" >提现</el-button>
                  </div>

            </div>
            <div class="home-left-top-one">
                <h3 class="a-title"> <i class="iconfont icon-zijinanquan"></i> 资金信息</h3>
                  <div class="home-left-top-capital">
                    <span>账户可用余额: <span class="available">{{currUserinfo.CurrUse}}</span>({{CurrencyName}}) </span>
                  </div>
                  <div class="home-left-top-capital">
                    <span>已提取:<span class="available">{{currUserinfo.TotalWithdraw}}</span>({{CurrencyName}})</span>
                  </div>
                  <div class="home-left-top-capital">
                    <span>提现中:<span class="available">{{currUserinfo.FrozenMoney}}</span>({{CurrencyName}})</span>
                  </div>
            </div>

            <div class="home-left-top-one">
                        <div class="bind-card" v-show="!displayCard">
                            <div class="bind-card-button" @click="showBindCardPage()">
                            <div class="bind-card-button-in">
                                +
                            </div>
                            </div>
                            <p style="padding-top:23px;text-align: center;">新增银行卡</p>
                        </div>
                        <div class="bankCardInfo" v-show="displayCard">
                            <h3 class="a-title"> <i class="iconfont icon-yinhangqia"></i> 我的银行卡</h3>
                            <div class="mcode square">
                                银行名称：{{SubbranchName}}
                            </div>
                            <div class="mname square">
                                银行卡号：<span style="color:#4be4c5;cursor:pointer;">{{CardNO}}</span>
                            </div>
                            </div>
            </div>

            <div class="home-left-top-one">
              <h3 class="a-title"> <i class="iconfont icon-touxiang"></i> 我的信息</h3>
              <div class="mine-info-list">
                <div class="mname square">
                  我的姓名：{{usernameinfo}}
                </div>
                <div class="mphone square" v-show="insTestProp.UserRelyPhone">
                  手机号码：
                  <span style="color:#4be4c5;cursor:pointer;"  v-show="noPhone" @click="showbindphone()"> 绑定 </span>
                  <span style="color:#4be4c5;cursor:pointer;"  v-show="havePhone">{{currAgentInfo.BindPhone}}</span>
                </div>
              </div>
            </div>

            <div class="home-left-top-one last-one">
              <h3 class="a-title"> <i class="iconfont icon-zijinzhanghu"></i> 我的证件</h3>
              <el-button type="primary" size="small" @click="openWallet()" v-if="!WalletOpenResult.IsOpen && isShowWallet">开通有钱钱包</el-button>
              <el-button type="primary" size="small" @click="gotoWallet()" v-if="WalletOpenResult.IsOpen && isShowWallet">去往有钱钱包</el-button>
              <!-- <el-popover
                v-if="WalletOpenResult.IsOpen && isShowWallet"
                popper-class='wallet-popper'
                placement="top-start"
                title="有钱钱包APP下载(Android)"
                trigger="hover">
                <div class="img">
                  <img :src="walletAndroidDownUrl" alt="">
                </div>
                <el-button slot="reference" type="primary" size="small">有钱钱包(Android)</el-button>
              </el-popover>
              <el-popover
                v-if="WalletOpenResult.IsOpen && isShowWallet"
                popper-class='wallet-popper'
                placement="top-start"
                title="有钱钱包APP下载(IOS)"
                trigger="hover">
                <div class="img">
                  <img :src="walletIOSDownUrl" alt="">
                </div>
                <el-button slot="reference" type="primary" size="small">有钱钱包(IOS)</el-button>
              </el-popover> -->
              <div class="mine-info-list">
                <!-- <template v-if="WalletOpenResult.IsOpen && isShowWallet">
                  <div class="mname square">
                    钱包姓名：<span style="color:#2399F1;cursor:pointer;"> {{WalletOpenResult.AccName}} </span>
                  </div>
                  <div class="mname square">
                    钱包账户：<span style="color:#2399F1;cursor:pointer;"> {{WalletOpenResult.AccNo}} </span>
                  </div>
                  <div class="mname square">
                    钱包余额：<span style="color:#2399F1;cursor:pointer;"> {{WalletOpenResult.Amount}} </span><el-button type="primary" size="small" @click="WalletWithdrawFn()">提现</el-button>
                  </div>
                  <hr>
                </template> -->
                <div class="mname square">
                  证件类型：身份证
                </div>
                <div class="mphone square">
                  身份证号：
                  <span style="color:#4be4c5;cursor:pointer;"  v-show="noid" @click="showbindid()"> 绑定 </span>
                  <span style="color:#4be4c5;cursor:pointer;"   v-show="haveid">{{IDCardNo}}</span>
                  <!--认证中 -->
                  <span style="color:#4be4c5;cursor:pointer;"   v-show="btnAuthing"> 认证中,请稍等！ </span>
                  <!-- 未通过 -->
                  <span style="color:#4be4c5;cursor:pointer;" @click="showbindid()"  v-show="nobind"> 未通过，请重新认证！ </span>
                </div>
              </div>
            </div>


          </div>
          <div class="home-left-bottom" style="position: relative;" v-show="isShowCashRecord">
            <el-tabs v-model="activeName">
              <el-tab-pane label="充值记录" name="first">
                <el-table :data="QueryHistoryMoneyTransfers" style="width: 100%;" v-loading="loading">
                  <el-table-column type="index" label="序号">
                  </el-table-column>
                  <el-table-column prop="TransferMoney" label="金额(元)">
                  </el-table-column>
                  <el-table-column prop="Id" label="交易号">
                  </el-table-column>
                  <el-table-column prop="AddDate" label="创建日期">
                  </el-table-column>
                  <el-table-column prop="OrderState" label="状态">
                  </el-table-column>
                </el-table>
              </el-tab-pane>
              <el-tab-pane label="提现记录" name="second">
                <el-table :data="withdrawList" style="width: 100%" v-loading="loading">
                  <el-table-column type="index" label="序号">
                  </el-table-column>
                  <el-table-column prop="TransferMoney" :label="'金额('+ CurrencyName +')'">
                  </el-table-column>
                  <el-table-column prop="Id" label="交易号">
                  </el-table-column>
                  <el-table-column prop="AddDate" label="创建日期">
                  </el-table-column>
                  <el-table-column prop="OrderState" label="状态">
                  </el-table-column>
                </el-table>
              </el-tab-pane>
            </el-tabs>
            <!-- <div class="line" style="width:1px;height:16px;background-color:#dbdbdb;position:absolute;top:12px;left:95px;"></div> -->
            <div style="position:absolute;top:20px;left:93%;">
              <!-- <router-link to="/history"></router-link> -->
              <a href="javascript:void(0);" @click="routerto()" style="color: #4be4c5;">更多...</a>
            </div>
          </div>
        </div>
      </div>
      <wallet ref="wallet"></wallet>
  </div>

</template>

<script>
import config from "../../static/config.json";
import Bus from '@/assets/js/bus';
import wallet from "@/components/modification/wallet.vue"
export default {
  name: "home",
  components: {
    wallet
  },
  data() {
    return {
      Agentcode:"",
      ml:"",
      xx:false,
      loading: "",
      buttonName: "发送短信验证码",
      isDisabled: false,
      time: 60,
      codephone: false,
      currUserinfo: {},
      activeName: "first",
      QueryHistoryMoneyTransfers: [],
      withdrawList: [],
      commissionList: [],
      PersonalAuthDialogForm: false,
      WithdrawDialogForm: false,
      bindPhonePage: false,
      ViewPrivacy: false,
      usernameinfo: "尚未进行实名认证",
      IDCardNo: "",
      currAgentInfo: {},
      currDate: "",
      YearsAgo: "",
      displayCard: "",
      CardNO: "",
      displayUsdt: "",
      UsdtAccountNO: "",
      SubbranchName: "",
      banklists: [],
      bankName: "",
      noid: false,
      haveid: false,
      btnAuthing: false,
      nobind: false,
      noPhone: true,
      havePhone: false,
      isShowPhone: true,
	  isShowIdCard:true,
      isShowCashRecord: true,
      insTestProp: {
        IsTestIns: true, // 是否测试机构，true测试机构
        UserRelyPhone: true, // 依赖手机号
        UseCustomId: true, // 使用自定义ID,false表示使用系统自动生成，true表示使用自定义ID
        AllowNonRealNameUserOpenPosition: false
      },
      WalletOpenResult: {
        IsOpen: false,
        Amount: '',
        AccNo: '',
        AccName: ''
      }, // 有钱钱包开通结果
      isShowWallet: false, // 当前是否支持有钱钱包功能
      walletIOSDownUrl: '../../static/wallet-ios-download.png',
      walletAndroidDownUrl: '../../static/wallet-Android-download.png',
      CurrencyName: '',
    };
  },
  created() {
    if (sessionStorage.getItem('isShowCashRecord') !== 'undefined' && sessionStorage.getItem('isShowCashRecord') !== '') {
      this.isShowCashRecord = JSON.parse(sessionStorage.getItem('isShowCashRecord'));
    }
    if (sessionStorage.getItem('isShowPhone') !== 'undefined' && sessionStorage.getItem('isShowPhone') !== '') {
      this.isShowPhone = JSON.parse(sessionStorage.getItem('isShowPhone'));
    }
	if (sessionStorage.getItem('isShowIdCard') !== 'undefined' && sessionStorage.getItem('isShowIdCard') !== '') {
	  this.isShowIdCard = JSON.parse(sessionStorage.getItem('isShowIdCard'));
	}
    this.currDate = new Date();
    let Year = this.currDate.getFullYear() - 1;
    let currMonth = this.currDate.getMonth() + 1;
    let currDate = this.currDate.getDate();
    this.YearsAgo = Year + "-" + currMonth + "-" + currDate;
    if(this.$Agentcode == "ml"){
      this.ml = true;
      this.xx = false;
    }else{
      this.xx = true;
      this.ml = false;
    }
    this.getCurrencyName();
  },
  mounted() {
    this.getUserIsSupportWallet();
    this.getBalanceInfo();
    this.QueryHistoryMoneyTransfer();
    this.getWithdrawList();
    this.getAgentInfo();
    this.getbankcode();
    this.getuserInfo();
    this.getusdtaccount();
    this.insTestProp = JSON.parse(sessionStorage.getItem("insTestProp"));
  },
  methods: {
    getCurrencyName() {
      var url = "/Account/GetInsBasicCurrency";
      var post = "";
      this.$loginapi.post(url, post, response => {
        if (response.Ret == 0) {
          this.CurrencyName = response.Data.Name;
        } else {
          this.$alert(response.Msg, {});
        }
      });
    },
    WalletWithdrawFn() {
      let url = "/Wallet/GetAccOperAuthUrl";
      let postData = 2;
      this.$loginapi.post(url, postData, response => {
        if (response.Ret == 0) {
          window.open(response.Data);
        } else {
          this.$message.error(response.Msg);
        }
      });
    },
    openWallet () {
      // this.$refs.wallet.WalletOpenAccountPre();
      let url = "/Wallet/AuthOper";
      let postData =  {
        OperType: 'real',
        Source: 2
      };
      this.loading = true;
      this.$loginapi.post(url, postData, response => {
        this.loading = false;
        if (response.Ret == 0) {
          window.open(response.Data)
        } else {
          this.$message.error(response.Msg);
        }
      });
    },
    gotoWallet () {
      let url = "/Wallet/AuthOper";
      let postData = {
        OperType: 'auth',
        Source: 2
      };
      this.loading = true;
      this.$loginapi.post(url, postData, response => {
        this.loading = false;
        if (response.Ret == 0) {
          window.open(response.Data)
        } else {
          this.$message.error(response.Msg);
        }
      });
    },
    // 获取用户是否支持有钱钱包功能
    getUserIsSupportWallet () {
      let url = "/Wallet/CanUseWallet";
      let postData = "";
      this.$loginapi.post(url, postData, response => {
        if (response.Ret == 0) {
          this.isShowWallet = response.Data;
          if (this.isShowWallet) {
            this.QryWalletOpenResult();
          }
        } else {
          // this.$message.error(response.Msg);
        }
      });
    },
    QryWalletOpenResult () {
      let url = "/Wallet/QryWalletOpenResult";
      let postData = "";
      this.$loginapi.post(url, postData, response => {
        if (response.Ret == 0) {
          this.WalletOpenResult.IsOpen = response.Data.IsOpen;
          this.WalletOpenResult.Amount = response.Data.Amount;
          this.WalletOpenResult.AccNo = response.Data.AccNo;
          this.WalletOpenResult.AccName = response.Data.AccName;
        } else {
          this.$message.error(response.Msg);
        }
      });
    },
    viewprivacy(row) {
      this.ViewPrivacy = true;
    },
    //充值页面
    select() {
      this.$router.push("/Recharge");
      Bus.$emit('activeIndex2','/Recharge')
    },
    // 提现页面
    withdrawdeposit() {
      if (this.displayCard || this.displayUsdt) {
        this.$router.push("/withdrawdeposit");
        Bus.$emit('activeIndex3','/withdrawdeposit')
      } else {
        this.$message.warning("请先绑定收款账户！");
      }
    },
    //获取当前代理人手机号码及认证信息
    getAgentInfo() {
      let url = "/Account/GetUserInfo";
      this.$loginapi.post(
        url,
        this.$store.state.userInfo.UserCode,
        response => {
          if (response.Ret == 0) {
            this.currAgentInfo = response.Data;
            if (
              this.currAgentInfo.BindPhone != null &&
              this.currAgentInfo.BindPhone != ""
            ) {
              this.noPhone = false;
              this.havePhone = true;
               this.currAgentInfo.BindPhone = this.currAgentInfo.BindPhone.replace(/(\d{3})\d{4}(\d{4})/,"$1****$2");
              if (!this.isShowPhone) {
                this.currAgentInfo.BindPhone = "***********";
              }
            }
          } else {
            this.$message.error(response.Msg);
          }
        }
      );
    },
    //获取当前登录用户身份证信息
    getuserInfo() {
      let infodata = {
        // InsCode: this.$store.state.userInfo.InsCode,
        // UserCode: this.$store.state.userInfo.UserCode,
        // UserType: this.$store.state.userInfo.UserType,
        WithImg:false
      };
      let url = "/RealNameAuth/IsAuthed";
      this.$loginapi.post(url, infodata, response => {
        if (response.Ret == 0) {
          if (response.Data.Result == 0) {
            this.noid = true;
            this.nobind = false;
            this.btnAuthing = false;
            this.haveid = false;
          }
          if (response.Data.Result == 1) {
            let url = "/RealNameAuth/GetInfoForMan";
            this.$loginapi.post(url, infodata, response => {
              if (response.Ret == 0) {
                this.usernameinfo = response.Data.RealName;
                this.IDCardNo = response.Data.IDCardNo;
                if (
                  response.Data.IDCardNo != null &&
                  response.Data.IDCardNo != ""
                ) {
                  this.noid = false;
                  this.nobind = false;
                  this.btnAuthing = false;
                  this.haveid = true;
				  if (!!this.isShowIdCard) {
						this.IDCardNo = this.IDCardNo.replace(/(\d{3})\d{11}(\d{4})/,"$1***********$2");
				  } else{
						this.IDCardNo = "**********************";
				  }
                  
                }
              } else {
              }
            });
          }
          if (response.Data.Result == 2) {
            this.nobind = false;
            this.noid = false;
            this.haveid = false;
            this.btnAuthing = true;
          }
          if (response.Data.Result == 3) {
            this.noid = false;
            this.haveid = false;
            this.btnAuthing = false;
            this.nobind = true;
          }
        } else {
          this.$message.error(response.Msg);
        }
      });
    },
    //获取账户余额
    getBalanceInfo() {
      let url = "/Account/GetBalance";
      this.$loginapi.post(url, "", response => {
        if (response.Ret == 0) {
           this.currUserinfo = response.Data
          // this.currUserinfo.CurrencyNo = response.Data.CurrWithdrawAble;
          //  this.currUserinfo.CurrWithdrawAble =  this.currUserinfo.CurrWithdrawAble.toFixed(2);
          //  this.currUserinfo.CurrWithdrawAble =  this.num(this.currUserinfo.CurrWithdrawAble,2);
          //  this.currUserinfo.CurrUse =  this.num(this.currUserinfo.CurrUse,2);
        } else {
          this.$message.error(response.Msg);
        }
      });
    },
    num(digit, length){
          length = length ? parseInt(length) : 0;
          if (length <= 0) return Math.round(digit);
          digit = Math.round(digit * Math.pow(10, length)) / Math.pow(10, length);
          return digit;
    },
    //充值记录
    QueryHistoryMoneyTransfer() {
      this.loading = true;
      let url = "/report/QueryHistoryMoneyTransfer";
      let postData = {
        MoneyTransType: 1,
        BeginDate: this.YearsAgo,
        EndDate: this.currDate
      };
      this.$loginapi.postWithPage(url, 1, 10, postData, response => {
        this.loading = false;
        if (response.Ret == 0) {
          this.QueryHistoryMoneyTransfers = response.Data;
        } else {
          this.$message.error(response.Msg);
        }
      });
    },
    //提现记录
    getWithdrawList() {
      this.loading = true;
      let url = "/report/QueryHistoryMoneyTransfer";
      let postData = {
        MoneyTransType: 2,
        BeginDate: this.YearsAgo,
        EndDate: this.currDate
      };
      this.$loginapi.postWithPage(url, 1, 10, postData, response => {
        this.loading = false;
        if (response.Ret == 0) {
          this.withdrawList = response.Data;
        } else {
          this.$message.error(response.Msg);
        }
      });
    },
    // 获取银行卡号
    getbankcode() {
      let url = "/Account/QueryBankCards";
      this.$loginapi.post(url, "", response => {
        if (response.Ret == 0) {
          if (response.Data.length > 0) {
            this.displayCard = true;
            this.SubbranchName = response.Data[0].BankName;
            this.CardNO = response.Data[0].CardNO;
            this.CardNO = this.CardNO.substr(0, 4) + "********" + this.CardNO.substr(-4);
          } else {
            this.displayCard = false;
          }
        } else {
          this.$message.error(response.Msg);
        }
      });
    },
    // 获取USDT钱包账户
    getusdtaccount() {
      let url = "/Account/QueryUsdtAccounts";
      this.$loginapi.post(url, "", response => {
        if (response.Ret == 0) {
          if (response.Data.length > 0) {
            this.displayUsdt = true;
            this.UsdtAccountNO = response.Data[0].AccountNO;
            this.UsdtAccountNO = response.Data[0].ViewAccountNO;
          } else {
            this.displayUsdt = false;
          }
        } else {
          this.$message.error(response.Msg);
        }
      });
    },

    //打开绑定银行卡页面
    showBindCardPage() {
      if (this.insTestProp.AllowNonRealNameUserOpenPosition){
        this.$router.push("/modification/bankcode");
        Bus.$emit('activeIndex4','')
        return;
      }
      if (this.insTestProp.UserRelyPhone) {
        if( this.currAgentInfo.BindPhone == "" ||  this.currAgentInfo.BindPhone == null){
          //  this.$alert('账户未绑定手机号，请先绑定手机号！', '', {
          //   confirmButtonText: '确定',
          //   callback: action => {
          //      this.$router.push("/modification/phone");
          //      Bus.$emit('activeIndex4','')
          //   }
          // });
          this.$message.warning("手机号未绑定，请先绑定手机号！");
          return;
        };
      }
      let infodata = {
        InsCode: this.$store.state.userInfo.InsCode,
        UserCode: this.$store.state.userInfo.UserCode,
        UserType: this.$store.state.userInfo.UserType
      };
      let url = "/RealNameAuth/IsAuthed";
      this.$loginapi.post(url, infodata, response => {
        if (response.Ret == 0) {
          if (response.Data.Result == 0) {
              //  this.$alert('账户未实名认证，请先实名认证！', '', {
              // confirmButtonText: '确定',
              // callback: action => {
              //   this.$router.push("/modification/personid");
              //    Bus.$emit('activeIndex4','')
              //    return;
              // }
              // });
             this.$message.warning("账户未实名认证，请先实名认证！");
             return;
          }
          if (response.Data.Result == 1) {
            let url = "/RealNameAuth/GetInfoForMan";
            this.$loginapi.post(url, infodata, response => {
              if (response.Ret == 0) {
                this.usernameinfo = response.Data.RealName;
                this.IDCardNo = response.Data.IDCardNo;
                 if (
                  response.Data.IDCardNo != null &&
                  response.Data.IDCardNo != ""
                ) {
                   this.$router.push("/modification/bankcode");
                    Bus.$emit('activeIndex4','')
                }
              } else {
              }
            });
          }
          if (response.Data.Result == 2) {
              // this.$alert('账户正在实名认证中,请等待审核！', '', {
              // confirmButtonText: '确定',
              // callback: action => {
              //   this.$router.push("/index");
              //     return;
              // }
              // });
             this.$message.warning("账户正在实名认证中,请等待审核！");
             return;
          }
          if (response.Data.Result == 3) {
              // this.$alert('账户实名认证失败,请重新实名认证！', '', {
              // confirmButtonText: '确定',
              // callback: action => {
              //   this.$router.push("/modification/personid");
              //   // Bus.$emit('activeIndex4','/modification/personid')
              //     return;
              // }
              // });
              this.$message.warning("账户实名认证失败,请重新实名认证！");
              return;
          }
        } else {
          this.$message.error(response.Msg);
        }
      });
    },

    //打开绑定银行卡页面
    showBindUsdtPage() {
      if (this.insTestProp.UserRelyPhone) {
        if( this.currAgentInfo.BindPhone == "" ||  this.currAgentInfo.BindPhone == null){
          //  this.$alert('账户未绑定手机号，请先绑定手机号！', '', {
          //   confirmButtonText: '确定',
          //   callback: action => {
          //      this.$router.push("/modification/phone");
          //      Bus.$emit('activeIndex4','')
          //   }
          // });
          this.$message.warning("手机号未绑定，请先绑定手机号！");
          return;
        };
      }
      let infodata = {
        InsCode: this.$store.state.userInfo.InsCode,
        UserCode: this.$store.state.userInfo.UserCode,
        UserType: this.$store.state.userInfo.UserType
      };
      let url = "/RealNameAuth/IsAuthed";
      this.$loginapi.post(url, infodata, response => {
        if (response.Ret == 0) {
          if (response.Data.Result == 0) {
              //  this.$alert('账户未实名认证，请先实名认证！', '', {
              // confirmButtonText: '确定',
              // callback: action => {
              //   this.$router.push("/modification/personid");
              //    Bus.$emit('activeIndex4','')
              //    return;
              // }
              // });
             this.$message.warning("账户未实名认证，请先实名认证！");
             return;
          }
          if (response.Data.Result == 1) {
            let url = "/RealNameAuth/GetInfoForMan";
            this.$loginapi.post(url, infodata, response => {
              if (response.Ret == 0) {
                this.usernameinfo = response.Data.RealName;
                this.IDCardNo = response.Data.IDCardNo;
                 if (
                  response.Data.IDCardNo != null &&
                  response.Data.IDCardNo != ""
                ) {
                   this.$router.push("/modification/bankcode");
                    Bus.$emit('activeIndex4','')
                }
              } else {
              }
            });
          }
          if (response.Data.Result == 2) {
              // this.$alert('账户正在实名认证中,请等待审核！', '', {
              // confirmButtonText: '确定',
              // callback: action => {
              //   this.$router.push("/index");
              //     return;
              // }
              // });
             this.$message.warning("账户正在实名认证中,请等待审核！");
             return;
          }
          if (response.Data.Result == 3) {
              // this.$alert('账户实名认证失败,请重新实名认证！', '', {
              // confirmButtonText: '确定',
              // callback: action => {
              //   this.$router.push("/modification/personid");
              //   // Bus.$emit('activeIndex4','/modification/personid')
              //     return;
              // }
              // });
              this.$message.warning("账户实名认证失败,请重新实名认证！");
              return;
          }
        } else {
          this.$message.error(response.Msg);
        }
      });
    },

    // 打开绑定手机页面
    showbindphone() {
      this.$router.push("/modification/phone");
      Bus.$emit('activeIndex4','')
    },
    // 打开绑定身份证页面
    showbindid() {
      this.$router.push("/modification/personid");
      Bus.$emit('activeIndex4','')
    },
    // 打开记录页面
    routerto(){
      this.$router.push("/history");
      Bus.$emit('activeIndex3','history')
    }
  }
};
</script>

<style>
.wallet-popper .el-popover__title {
  text-align: center;
}
.wallet-popper .img {
  width: 252px;
  height: 252px;
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue